import styled from 'styled-components';
import YouTubePlayer from 'react-youtube';
import DotSVG from 'components/DotSVG/index.js';
import { mediaBreakpointUp } from 'utils/styledCssHelpers';

export const CustomVideo = styled(YouTubePlayer)`

    height: 160px;
    width: 284px;

    ${mediaBreakpointUp(
      'sm',
      `
      height: 281px;
    width: 500px;
    `,
    )}
    ${mediaBreakpointUp(
      'md',
      `
      height: 287px;
    width: 510px;
    `,
    )}
    ${mediaBreakpointUp(
      'lg',
      `
      height: 430px;
      width: 764px;
    `,
    )}
    ${mediaBreakpointUp(
      'xl',
      `
      height: 506px;
      width: 900px;
    `,
    )}
  }
  & .poster > div div {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-50%);
  }
`;

export const StarSvg = styled(DotSVG)`
  transform: translateY(-17px);
  z-index: -1;
  position: relative;
  width: 100%;
  display: block;
`;
